import React from "react";
import { MDXProvider } from "@mdx-js/react";

import CarouselComponent from "./src/components/Carousel";
import CarouselSeamlessComponent from "./src/components/CarouselSeamless";
import ProjectProse from "./src/components/ProjectProse";
import ProjectSection from "./src/components/ProjectSection";

const components = {
  Section: ProjectSection,
  Prose: ProjectProse,
  Carousel: CarouselComponent,
  CarouselSeamless: CarouselSeamlessComponent,
};

export const wrapRootElement = ({ element }) => (
  <MDXProvider components={components}>{element}</MDXProvider>
);
